module.exports = __webpack_public_path__ + "img/logo-SOLANA-tmp.090b8f20.svg";